var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "flat": "",
      "tile": "",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('span', [_vm._v(" 근로계약 출근내역 ")])]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('v-data-table', _vm._b({
    staticClass: "rounded-0",
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value,
            item = _ref.item;
          return [_c('div', {
            key: header.value
          }, [_vm._v(_vm._s(header.formatter(value, item)))])];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    mobileBreakPoint: _vm.$vuetify.breakpoint.thresholds.sm
  }, false)), _c('v-divider'), _c('v-pagination', {
    staticClass: "employment-contract-view-logs__pagination",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('client-loader', _vm._b({}, 'client-loader', {
    loading: _vm.loading
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }